import React, {Component} from "react";
import {Redirect, Route, Router, Switch} from "react-router-dom";
import browserHistory from "utils/browserHistory";
import VideoForm from "./VideoForm";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import {VIDEO_TYPES} from "./constants";
import {Add} from "@material-ui/icons";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import _ from "lodash";
import {request} from "../../api-client";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import localization from "../../config/localization"
import {FormControl, FormControlLabel, Radio, RadioGroup} from "@material-ui/core/index";
import {makeImageUrlWithSize} from "../../layouts/Home/HomeElements/utils";

const getBaseVideos = () => VIDEO_TYPES.toArray().reduce((acc, next) => ({ ...acc, [next]: [] }), {});

class VideoListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: getBaseVideos(),
      deleteVideo: null,
      requestingDelete: false,
      requestingVideos: false,
      bannersFrom: 'all'
    };
  }

  componentDidMount = () => {
    this.fetchVideos();
    document.title = localization.get("videos") + " - Bloomclouds";
  }

  fetchVideos = () => {
    this.setState({ requestingVideos: true });
    return request.featuredVideo
      .all()
      .then(videos => {
        const base = getBaseVideos();
        const byType = _.groupBy(videos, "type");
        this.setState({ videos: { ...base, ...byType } });
      })
      .finally(() => this.setState({ requestingVideos: false }));
  };

  render = () => {
    return (
      <div>
        {this.renderDeleteVideoDialog()}
        {VIDEO_TYPES.toArray().map(x => (
          <div key={x}>{this.renderVideosOfType(x)}</div>
        ))}
      </div>
    );
  };

  renderDeleteVideoDialog = () =>
    this.state.deleteVideo !== null && (
      <Dialog open>
        <DialogTitle>{localization.get('delete')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {localization.get('video.delete_warning', [this.state.deleteVideo.title, VIDEO_TYPES.toString(this.state.deleteVideo.type)])}

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ deleteVideo: null })} disabled={this.state.requestingDelete}>
            {localization.get('cancel')}
          </Button>
          <Button
            onClick={() => {
              this.setState({ requestingDelete: true }, () => {
                request.featuredVideo
                  .delete(this.state.deleteVideo.id)
                  .then(this.fetchVideos)
                  .finally(() => this.setState({ requestingDelete: false, deleteVideo: null }));
              });
            }}
            disabled={this.state.requestingDelete}
          >
            {localization.get('accept')}
          </Button>
        </DialogActions>
      </Dialog>
    );

  renderVideosOfType = type => (
    <Card>
      <CardHeader color="primary" text>
        <CardText style={{ background: "linear-gradient(60deg, #000000, #1f1f1f)", boxShadow: "none" }} color="primary">
          <span style={{ marginRight: 20 }}>{VIDEO_TYPES.toString(type)}</span>
          <Tooltip title={localization.get('tooltip.add')}>
            <IconButton onClick={() => this.handleCreate(type)} style={{ width: 24, height: 24 }}>
              <Add style={{ color: "white" }} />
            </IconButton>
          </Tooltip>
        </CardText>
      </CardHeader>
      <CardBody>{this.renderVideos(type)}</CardBody>
    </Card>
  );

  renderVideos = type => {
    if (this.state.videos[type].length === 0) {
      return <div>{localization.get('video.no_videos')}</div>;
    }
    return (
      <>
        <FormControl style={{width: "100%", float: "left", position: "relative"}}>
          <RadioGroup
            name="bannersFrom"
            value={this.state.bannersFrom}
            onChange={e => this.setState({bannersFrom: e.target.value})}
            style={{ width: "100%", float: "left", position: "relative", flexDirection: "row" }}
          >
            <FormControlLabel value="all" control={<Radio color="default" />} label={localization.get('all')} />
            <FormControlLabel value="twins" control={<Radio color="default" />} label={localization.get('banners_twins')} />
            <FormControlLabel value="bloomclouds" control={<Radio color="default" />} label={localization.get('banners_bloomclouds')} />
            <FormControlLabel value="other" control={<Radio color="default" />} label={localization.get('banners_other')} />
          </RadioGroup>
        </FormControl>
        <div style={{ width: "100%", float: "left", position: "relative", marginTop: 20 }}>
          <div style={{display: "flex", flexFlow: "wrap"}}>
            {this.state.videos[type]
              .sort((a, b) => (a.order < b.order ? -1 : a.order === b.order ? 0 : 1))
              .map((video) => {
                if (this.state.bannersFrom === 'bloomclouds') {
                    if (!video.platform_banner) {
                      return false
                    }
                }
                /*Validate against client Twins Music id on DB*/
                if (this.state.bannersFrom === 'twins') {
                  let value = true
                  video.clients.forEach(client => {
                    if (client.id === 20) {
                      value = false
                    }
                  })
                  if (value) {
                    return false
                  }
                }
                /*Other banners*/
                if (this.state.bannersFrom === 'other') {
                  let value = false
                  video.clients.forEach(client => {
                    if (client.id === 20) {
                      value = true
                    }
                  })
                  if (video.platform_banner || value) {
                    return false
                  }
                }
                return (
                  <div>
                    {this.renderVideoElement(video)}
                  </div>
                )
              })}
          </div>
        </div>
      </>
    )
  }

/*  renderDragAndDrop = type => {
    if (this.state.videos[type].length === 0) {
      return <div>{localization.get('video.no_videos')}</div>;
    }
    return (
      <DragDropContext
        onDragEnd={result => {
          if (result.destination) {
            const destination = result.destination.index;
            const source = result.source.index;

            if (destination !== source) {
              const videos = this.state.videos[type];
              const sourceId = videos[source].id;
              const destinationOrder = videos[destination].order;
              const direction = destination < source ? -1 : 1;
              const involved =
                direction === -1 ? videos.slice(destination, source) : videos.slice(source + 1, destination + 1);
              videos[source].order = videos[destination].order;
              involved.forEach(x => (x.order -= direction));
              this.forceUpdate();
              this.setState({ requestingVideos: true });
              request.featuredVideo.setOrder(sourceId, destinationOrder).then(this.fetchVideos);
            }
          }
        }}
      >
        <Droppable
          droppableId={VIDEO_TYPES.toString(type)}
          direction="horizontal"
          isDropDisabled={this.state.requestingVideos}
        >
          {provided => (
            <div
              ref={provided.innerRef}
              style={{
                display: "flex",
                padding: 10,
                overflow: "auto",
              }}
              {...provided.droppableProps}
            >
              {this.state.videos[type]
                .sort((a, b) => (a.order < b.order ? -1 : a.order === b.order ? 0 : 1))
                .map((video, index) => (
                  <Draggable key={video.id.toString()} draggableId={video.id.toString()} index={index}>
                    {provided => (
                      <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        {this.renderVideoElement(video)}
                      </div>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };*/

  renderVideoElement = video => (
      <Paper key={video.id} style={{ margin: "0 25px 20px", width: 400 }}>
      {video.video ?
        <video
          src={video.video.url + "#t=1"}
          style={{ backgroundColor: "black", width: 400, height: 225 }}
          controls
        />
        :
        <img style={{width: "100%", height: "225px", objectFit: "cover"}} src={makeImageUrlWithSize(video, 'md')}/>
      }
      <div style={{ padding: 10 }}>
        <Typography>{video.title}</Typography>
        <Typography variant="caption">{video.subtitle}</Typography>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20 }}>
          <Button onClick={() => this.handleEdit(video)}>{localization.get('edit')}</Button>
          <Button onClick={() => this.handleDelete(video)}>{localization.get('delete')}</Button>
        </div>
      </div>
    </Paper>
  );

  handleCreate = type => this.props.history.push(this.props.match.path + "/create?type=" + type);
  handleEdit = video => this.props.history.push(this.props.match.path + "/" + video.id + "/update");
  handleDelete = video => this.setState({ deleteVideo: video });
}

class VideoConfig extends Component {
  render = () => (
    <Router history={browserHistory}>
      <Switch>
        <Route path="/panel/videos/create" component={VideoForm} />
        <Route path="/panel/videos/:videoId/update" component={VideoForm} />
        <Route path="/panel/videos" component={VideoListing} />
        <Route render={() => <Redirect to="/videos" />} />
      </Switch>
    </Router>
  );
}

export default VideoConfig;